import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rFaaliyetAlaniListesi } from '../../../../api/models/.catalog';

export default ApiBaseReducer<pList, IInputDataStateModel<pList, rFaaliyetAlaniListesi[]>, rFaaliyetAlaniListesi[]>(
    ActionSubTypes.API_FAALIYETALANILISTESI,
    DefaultInputDataStateModel<pList, rFaaliyetAlaniListesi[]>()
);
